import { render } from "./brokerageRoport.vue?vue&type=template&id=6f4e87ef&scoped=true"
import script from "./brokerageRoport.vue?vue&type=script&lang=js"
export * from "./brokerageRoport.vue?vue&type=script&lang=js"

import "./brokerageRoport.vue?vue&type=style&index=0&id=6f4e87ef&lang=scss&scoped=true"
import "./brokerageRoport.vue?vue&type=style&index=1&id=6f4e87ef&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4e87ef"]])

export default __exports__